import { render, staticRenderFns } from "./AuthorizedCallback.vue?vue&type=template&id=0524d34e&"
import script from "./AuthorizedCallback.vue?vue&type=script&lang=ts&"
export * from "./AuthorizedCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports